import enhance from './DataTable.enhancer'
import DataTable from './DataTable'

export default enhance(DataTable)



// WEBPACK FOOTER //
// ./src/components/organisms/DataTable/index.js